<template>
	<div class="page">
		<top-header></top-header>
		<div class="cont-box">
		<b-container fluid style="margin-top:5%;">
			<b-row class="mt-3 mb-2">
				<b-col class="col-md-6 col-sm-6 col-xs-6">
					<h3 class="text-white">Manage User Roles</h3>
				</b-col>
				<b-col class="col-md-6 col-sm-6 col-xs-6 text-right">
					<b-button variant="dark" pill class="mr-2" @click="showAddModal()">Add Role</b-button>
					<b-button variant="dark" pill  @click="downloadcsv()">Export</b-button>
				</b-col>
			</b-row>
		</b-container>
		<b-container fluid>
			<b-row>
				<b-col class="col-md-12 col-sm-12 col-xs-12">
					<div class="container-box">
						<b-row class="mt-4 px-2 mb-2">
							<b-col lg="6">
								<span class="mr-2">Show</span>
								<b-form-select v-model="perPage" id="perPageSelect" :options="pageOptions" size="sm" class="w-25">
								</b-form-select>
								<span class="ml-2">entries</span>
							</b-col>
							<b-col lg="4" offset-md="2">
								<b-form-group label="Filter" label-cols-sm="3" label-align-sm="right" label-size="sm" label-for="filterInput" class="mb-0">
									<b-input-group size="sm">
										<b-form-input v-model="filter" type="search" id="filterInput" placeholder="Type to Search">
										</b-form-input>
										<b-input-group-append>
											<b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
										</b-input-group-append>
									</b-input-group>
								</b-form-group>
							</b-col>
						</b-row>
						<b-row class="px-3 py-3">
							<b-col lg="12">
								<b-table show-empty sticky-header small striped outlined id="my-table" stacked="md" :items="records" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :filterIncludedFields="filterOn" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered">
									

									<template #cell(id)="records">
										{{ records.index+1}}
									</template>
									
									<template v-slot:cell(network)="row">
										<b-badge pill variant="danger" v-if="row.value == 0">Inactive</b-badge>
										<b-badge pill variant="success" v-else>Active</b-badge>
									</template>
									<template v-slot:cell(actions)="row">
										<b-button pill variant="primary" class="mr-1" @click="showUpdateModal(row.item, row.index, $event.target)" size="sm">EDIT</b-button>
										<b-button pill variant="danger" class="mr-1" @click="showDeleteModal(row.item)" size="sm">DELETE</b-button>
									</template>
								</b-table>
							</b-col>
						</b-row>
						<b-row class="px-3 mb-3">
							<b-col lg="6">
								<span class="mr-2">Showing 1 to 5 of {{records.length}} entries</span>
							</b-col>
							<b-col lg="3" offset-md="3">
								<b-pagination v-model="currentPage" pills :total-rows="totalRows" :per-page="perPage" align="right" size="sm" prev-text="Prev" next-text="Next" first-number last-number></b-pagination>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>
			
			<b-modal id="my-modal" :title="(selectedItem.id > 0)?'Edit Roles':'Add Roles'" size="lg" ok-only @hidden="resetSelectedItem" @ok="modalSubmit">
				<form ref="form" @submit.stop.prevent="handleSubmit">
					<b-form-group label="Title" label-cols="3" label-size="sm" label-align-sm="right" invalid-feedback="Imei is required">
						<b-form-input class="w-50" v-model="selectedItem.title" :disabled="selectedItem.id > 0" required></b-form-input>
					</b-form-group>
					<b-form-group label="Status" label-for="status" label-cols="3" label-size="sm" label-align-sm="right">
						<b-form-select class="w-50" v-model="selectedItem.status" :options="$root.status_options" required></b-form-select>
					</b-form-group>
					<b-form-group label="Permissions" label-for="fp-input" label-cols="3" label-size="sm" label-align-sm="right">
						<separator class="mt-2" title="Pages"></separator>
						<h6>Page Devices</h6>
						<b-form-checkbox-group v-model="selectedItem.options.page_devices" name="page-device">
							<b-form-checkbox value="enabled">Enabled</b-form-checkbox>
							<b-form-checkbox value="replace">Replace CCMS/DCU</b-form-checkbox>
							<b-form-checkbox value="view">View CCMS/DCU</b-form-checkbox>
							<b-form-checkbox value="add">Add CCMS/DCU</b-form-checkbox>
							<b-form-checkbox value="edit">Edit CCMS/DCU</b-form-checkbox>
							<b-form-checkbox value="delete">Delete CCMS/DCU</b-form-checkbox>
							<b-form-checkbox value="light_fault_list">Display Light Fault List</b-form-checkbox>
							<b-form-checkbox value="maintenance">Maintenance</b-form-checkbox>
							<b-form-checkbox value="control">Controls</b-form-checkbox>
							<b-form-checkbox value="export">Export</b-form-checkbox>
						</b-form-checkbox-group>

						<h6 class="mt-2">Page Control</h6>
						<b-form-checkbox-group v-model="selectedItem.options.page_control" name="page-control">
							<b-form-checkbox value="enabled">Enabled</b-form-checkbox>
						</b-form-checkbox-group>
						
						<h6 class="mt-2">Page Complaints</h6>
						<b-form-checkbox-group v-model="selectedItem.options.page_complaint" name="page-complaint">
							<b-form-checkbox value="enabled">Enabled</b-form-checkbox>
							<b-form-checkbox value="view">View</b-form-checkbox>
							<b-form-checkbox value="add">Add</b-form-checkbox>
							<b-form-checkbox value="edit">Edit</b-form-checkbox>
							<b-form-checkbox value="change_status">Change Status</b-form-checkbox>
							<b-form-checkbox value="delete">Delete</b-form-checkbox>
						</b-form-checkbox-group>
						
						<separator class="mt-2" title="Reports"></separator>
						<h6>ULB Reports</h6>
						<b-form-checkbox-group v-model="selectedItem.options.ulb_reports" :options="$root.page_report_perm_options" name="flavour-1"></b-form-checkbox-group>
						<h6 class="mt-2">CCMS/DCU Reports</h6>
						<b-form-checkbox-group v-model="selectedItem.options.device_reports" :options="$root.page_report_perm_options" name="flavour-1"></b-form-checkbox-group>

						<separator class="mt-2" title="Settings"></separator>
						<h6>Manage User</h6>
						<b-form-checkbox-group v-model="selectedItem.options.page_users" :options="$root.page_perm_options" name="flavour-1"></b-form-checkbox-group>
						<h6 class="mt-2">Manage Roles</h6>
						<b-form-checkbox-group v-model="selectedItem.options.page_roles" :options="$root.page_perm_options" name="flavour-1"></b-form-checkbox-group>
						<h6 class="mt-2">Manage ULBs</h6>
						<b-form-checkbox-group v-model="selectedItem.options.page_ulbs" name="flavour-1">
							<b-form-checkbox value="enabled">Enabled</b-form-checkbox>
							<b-form-checkbox value="view">View</b-form-checkbox>
							<b-form-checkbox value="add">Add</b-form-checkbox>
							<b-form-checkbox value="edit">Edit</b-form-checkbox>
							<b-form-checkbox value="delete">Delete</b-form-checkbox>
							<b-form-checkbox value="schedule">Schedule</b-form-checkbox>
						</b-form-checkbox-group>
						<h6 class="mt-2">Manage City</h6>
						<b-form-checkbox-group v-model="selectedItem.options.page_cities" name="flavour-1">
							<b-form-checkbox value="enabled">Enabled</b-form-checkbox>
							<b-form-checkbox value="add">Add</b-form-checkbox>
							<b-form-checkbox value="edit">Edit</b-form-checkbox>
							<b-form-checkbox value="delete">Delete</b-form-checkbox>
						</b-form-checkbox-group>
						<h6 class="mt-2">Manage Zones</h6>
						<b-form-checkbox-group v-model="selectedItem.options.page_zones" :options="$root.page_perm_options" name="flavour-1"></b-form-checkbox-group>
						<h6 class="mt-2">Manage Wards</h6>
						<b-form-checkbox-group v-model="selectedItem.options.page_wards" name="flavour-1">
							<b-form-checkbox value="enabled">Enabled</b-form-checkbox>
							<b-form-checkbox value="add">Add</b-form-checkbox>
							<b-form-checkbox value="edit">Edit</b-form-checkbox>
							<b-form-checkbox value="delete">Delete</b-form-checkbox>
						</b-form-checkbox-group>
						<h6 class="mt-2">Master Devices</h6>
						<b-form-checkbox-group v-model="selectedItem.options.master_devices" name="flavour-1">
							<b-form-checkbox value="enabled">Enabled</b-form-checkbox>
							<b-form-checkbox value="view">View</b-form-checkbox>
							<b-form-checkbox value="sms">SMS</b-form-checkbox>
							<b-form-checkbox value="replace">Replace</b-form-checkbox>
							<b-form-checkbox value="edit">Edit</b-form-checkbox>
							<b-form-checkbox value="delete">Delete</b-form-checkbox>
						</b-form-checkbox-group>

						<h6 class="mt-2">Corrections</h6>
						<b-form-checkbox-group v-model="selectedItem.options.corrections" name="flavour-1">
							<b-form-checkbox value="enabled">Enabled</b-form-checkbox>
						</b-form-checkbox-group>

						<h6 class="mt-2">Check Devices</h6>
						<b-form-checkbox-group v-model="selectedItem.options.find_device" name="find-device">
							<b-form-checkbox value="enabled">Enabled</b-form-checkbox>
							<b-form-checkbox value="view">View</b-form-checkbox>
							<b-form-checkbox value="sms">SMS</b-form-checkbox>
							<b-form-checkbox value="replace">Replace</b-form-checkbox>
							<b-form-checkbox value="edit">Edit</b-form-checkbox>
							<b-form-checkbox value="delete">Delete</b-form-checkbox>
						</b-form-checkbox-group>

						<h6 class="mt-2">Tariff Rate</h6>
						<b-form-checkbox-group v-model="selectedItem.options.tariff_rate" name="schedule">
							<b-form-checkbox value="enabled">Enabled</b-form-checkbox>
							<b-form-checkbox value="view">View</b-form-checkbox>
							<b-form-checkbox value="add">Add</b-form-checkbox>
							<b-form-checkbox value="edit">Edit</b-form-checkbox>
						</b-form-checkbox-group>

						<h6 class="mt-2">Schedule</h6>
						<b-form-checkbox-group v-model="selectedItem.options.schedule" name="schedule">
							<b-form-checkbox value="enabled">Enabled</b-form-checkbox>
							<b-form-checkbox value="view">View</b-form-checkbox>
							<b-form-checkbox value="add">Add</b-form-checkbox>
							<b-form-checkbox value="edit">Edit</b-form-checkbox>
						</b-form-checkbox-group>
						<h6 class="mt-2">Unregistered Devices</h6>
						<b-form-checkbox-group v-model="selectedItem.options.unregistered" name="schedule">
							<b-form-checkbox value="enabled">Enabled</b-form-checkbox>
							<b-form-checkbox value="view">View</b-form-checkbox>
							<b-form-checkbox value="add">Add</b-form-checkbox>
						</b-form-checkbox-group>

						<h6 class="mt-2">Broadcast Permission</h6>
						<b-form-checkbox-group v-model="selectedItem.options.broadcast" name="schedule">
							<b-form-checkbox value="enabled">Enabled</b-form-checkbox>
							<b-form-checkbox value="lighton">Light ON</b-form-checkbox>
							<b-form-checkbox value="lightoff">Light OFF</b-form-checkbox>
							<b-form-checkbox value="rtc">RTC</b-form-checkbox>
							<b-form-checkbox value="schedule">SCHEDULE</b-form-checkbox>
						</b-form-checkbox-group>
						
						<h6 class="mt-2">Change Password</h6>
						<b-form-checkbox-group v-model="selectedItem.options.change_password" name="option-changepassword">
							<b-form-checkbox value="enabled">Enabled</b-form-checkbox>
						</b-form-checkbox-group>
					</b-form-group>
				</form>
				<template v-slot:modal-footer="{ ok, close }">
					<b-button size="sm" variant="danger" @click="close()">Cancel</b-button>
					<b-button size="sm" variant="success" @click="ok()">{{(selectedItem.id > 0)?'Update':'Submit'}}</b-button>
				</template>
			</b-modal>
		
		</b-container>
		<transition name="fade">
			<b-row v-if="loading" class="loading" align-v="center" align-h="center">
				<b-spinner label="Busy" variant="light"></b-spinner>
			</b-row>
		</transition>
	</div>
</div>
	
</template>
<script>
import Header from "@/components/Header.vue";
import Separator from "@/components/Separator.vue";
export default {
	name: 'Devices',
	components: {
		"top-header": Header,
		"separator": Separator
	},
	mounted(){
		this.initload();
	},
	data() {
		var self = this;
		return{
			loading: true, 
			email: '',
			password: '',
			recordUrl: self.$session.get('apiurl')+'aligarhapi/user-roles',
			insertUrl: self.$session.get('apiurl')+'aligarhapi/role-insert',
			updateUrl: self.$session.get('apiurl')+'aligarhapi/role-update',
			deleteUrl: self.$session.get('apiurl')+'aligarhapi/role-delete',
			records: [],
			incid:1,
			fields: [
				{ key: 'id', label: 'ID', sortable: true, sortDirection: 'desc' },
				{ key: 'title', label: 'Title', sortable: true, class: 'text-center' },
				{ key: 'options', label: 'Permissions'},
				{ key: 'status', label: 'Status' },
				{ key: 'actions', label: 'Actions', 'extra': 1 }
			],
			page_devices_permission: [
				{ text: 'Enabled', value: 'enabled' },
				{ text: 'View', value: 'view' },
				{ text: 'Edit', value: 'edit' },
				{ text: 'Delete', value: 'delete' }
			],
			page_zones_permission: [
				{ text: 'Enabled', value: 'enabled' },
				{ text: 'View', value: 'view' },
				{ text: 'Edit', value: 'edit' },
				{ text: 'Delete', value: 'delete' }
			],
			totalRows: 1,
			currentPage: 1,
			pageOptions: [10, 20, 50, 100],
			perPage: 10,
			sortBy: '',
			sortDesc: false,
			sortDirection: 'asc',
			filter: null,
			filterOn: [],
			selectedItem: {options:{}},
			emptyItem: {
				id: 0,
				title: '',
				options: {page_dashboard:[]},
				status: ''
			}
		};
	},
	methods: {
		showAddModal(){
			this.selectedItem = Object.assign({}, this.emptyItem);
			this.$root.$emit('bv::show::modal', 'my-modal');
		},
		showUpdateModal(item, index, button) {
			this.selectedItem = Object.assign({}, item);
			this.selectedItem.options = JSON.parse(item.options);
			this.$root.$emit('bv::show::modal', 'my-modal', button)
		},
		showViewModal(item, button){
			this.selectedItem = Object.assign({}, item);
			this.$root.$emit('bv::show::modal', 'view-model', button);
		},
		showDeleteModal(item){
			var self = this;
			this.$bvModal.msgBoxConfirm('Please confirm that you want to delete role.', {
				title: 'Please Confirm',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'YES',
				cancelTitle: 'NO',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			})
			.then(value => {
				if(value == true){
					self.axios.post(self.deleteUrl, {
						accesskey: self.$session.get('access_key'),
						deleteid: item.id
					})
					.then(function (response) {
						if(response.data.error == 0 || response.data.error == '0'){
							self.$bvToast.toast(response.data.message, {
								title: 'Delete',
								toaster: 'b-toaster-bottom-right',
								autoHideDelay: 5000,
								variant: 'warning',
								solid: true,
								appendToast: true
							});
							self.initload();
						}
						
					})
					.catch(function (error) {
						alert(error);
					});
				}else{
					//alert('no '+item.id);
				}
			})
			.catch(err => {
				// An error occurred
				console.log(err);
			})
		},
		modalSubmit(bvModalEvt){
			var self = this;
			self.loading = true;
			bvModalEvt.preventDefault();
			var submitUrl = "";
			if(self.selectedItem.id == 0){
				submitUrl = self.insertUrl;
			}else{
				submitUrl = self.updateUrl;
			}
			//console.log(submitUrl);
			//console.log(console.log(JSON.stringify(self.selectedItem)));
			

			
			self.axios.post(submitUrl, {
				accesskey: self.$session.get('access_key'),
				data: self.selectedItem
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.$bvModal.hide('my-modal');
					self.$bvToast.toast(response.data.message, {
						title: 'Status',
						toaster: 'b-toaster-bottom-right',
						autoHideDelay: 5000,
						variant: 'warning',
						solid: true,
						appendToast: true
					});
					self.initload();
				}
				
			})
			.catch(function (error) {
				alert(error);
			});
		},
		
		

		resetSelectedItem(){
			this.selectedItem = Object.assign({}, this.emptyItem);
		},
		initload(){
			var self = this;
			
			self.axios.post(self.recordUrl, {
				accesskey: self.$session.get('access_key')
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.records = response.data.result;
					self.loading = false;
					self.totalRows = self.records.length;
				}
			})
			.catch(function (error) {
				alert(error);
			});
			//alert('login '+self.email+" "+self.password);
		},
		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length
			this.currentPage = 1
		},
		downloadcsv(){
			var self = this;
			var header = new Array()
			self.fields.forEach(function(item){
				if(!item.extra){
					header.push(item.label);
				}
			});
			
			//var d = table.rows().data();
			var finalarr = new Array();
			finalarr.push(header);
			self.records.forEach(function(row){
				var dataarr = new Array();
				self.fields.forEach(function(field){
					if(field.key != 'extra'){
						dataarr.push(row[field.key]);
					}
				});
				finalarr.push(dataarr);
			});
			
			let csvContent = "data:text/csv;charset=utf-8," 
			+ finalarr.map(e => e.join(",")).join("\n");

			var encodedUri = encodeURI(csvContent);
			var link = document.createElement("a");
			link.setAttribute("href", encodedUri);
			link.setAttribute("download", "device_report.csv");
			document.body.appendChild(link); // Required for FF

			link.click();
		}
	}
}
</script>
<style>
html{
	min-height: 100%;
}
body{
	background-image: url(../assets/home-banner.png) !important;
	background-repeat: no-repeat;
	background-size: cover;
	/* background-position: center center; */
	background-position: bottom;
   
}
.table{
	font-size: small;
}
.table .btn{
	font-size: 12px;
}
.table td, .table th{
	vertical-align: middle;
}


.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to{
  opacity: 0;
}
</style>